import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { Progress } from '@/components/ui/progress';

export const CaseEvaluationPanel = ({ caseEvaluation }) => {
  if (!caseEvaluation) return null;

  return (
    <Card className="mb-8 border-2 border-emerald-200 bg-gradient-to-br from-emerald-50 via-white to-teal-50">
      <CardHeader className="border-b border-emerald-100">
        <CardTitle className="text-emerald-900 flex items-center gap-2">Clinical Learning Value Assessment</CardTitle>
        <p className="text-sm text-slate-600 mt-2">AI-powered evaluation of this case report's educational and clinical learning value</p>
      </CardHeader>
      <CardContent className="pt-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
          <div className="p-4 bg-blue-50 border border-blue-200 rounded-lg">
            <div className="text-sm text-blue-700 mb-1">Clinical Learning Value</div>
            <div className="text-3xl font-bold text-blue-600">{caseEvaluation.clinical_learning_value?.toFixed(1)}/10</div>
          </div>
          <div className="p-4 bg-purple-50 border border-purple-200 rounded-lg">
            <div className="text-sm text-purple-700 mb-1">Clinical Value Score</div>
            <div className="text-3xl font-bold text-purple-600">{caseEvaluation.evidence_equivalent?.toFixed(1)}/35</div>
            <div className="text-xs text-purple-600 mt-1">({caseEvaluation.clinical_learning_value?.toFixed(1)} x 3.5)</div>
          </div>
        </div>

        {caseEvaluation.evaluation_explanation && (
          <div className="mb-4 p-4 bg-white border border-emerald-200 rounded-lg">
            <div className="font-semibold text-slate-900 mb-2">Overall Assessment</div>
            <p className="text-sm text-slate-700">{caseEvaluation.evaluation_explanation}</p>
          </div>
        )}

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {[
            { label: 'Documentation Quality', value: caseEvaluation.documentation_quality, max: 3, key: 'documentation_quality' },
            { label: 'Novelty / Rarity', value: caseEvaluation.novelty_rarity, max: 3, key: 'novelty_rarity' },
            { label: 'Educational Value', value: caseEvaluation.educational_value, max: 2, key: 'educational_value' },
            { label: 'Follow-up & Outcome', value: caseEvaluation.followup_outcome, max: 2, key: 'followup_outcome' },
          ].map((item) => (
            <div key={item.key} className="p-4 bg-white border border-emerald-200 rounded-lg">
              <div className="flex justify-between items-center mb-2">
                <span className="font-semibold text-slate-900">{item.label}</span>
                <span className="text-lg font-bold text-emerald-600">{item.value?.toFixed(1)}/{item.max}</span>
              </div>
              {caseEvaluation.component_justifications?.[item.key] && (
                <p className="text-xs text-slate-600 mt-1">{caseEvaluation.component_justifications[item.key]}</p>
              )}
              <Progress value={(item.value / item.max) * 100} className="h-2 bg-emerald-100 mt-2" />
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};
